<template>
    <div style="position: absolute;top: 0;right: 0;bottom: 0;left: 0;display: flex;flex-direction: column">
        <!-- 导航栏 -->
        <van-nav-bar title="通知公告" left-arrow @click-left="onClickLeft" />
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh" style="flex: 1;background-color: rgb(247, 248, 250);overflow: scroll">
            <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有了"
                    @load="onLoad"
            >
                <div
                       v-for="(item,index) in list"
                        :key="index"
                        style="background: #fff;display: flex;padding: 5px 10px; align-items: center;"
                        @click="onItemClick(item)"
                >
					<van-icon name="volume-o"   size="20px" color="orange"/>
                    <!-- <img :src="item.userInfo.headImgUrl" width="50" height="50" style="margin: 5px;border-radius: 5px;"> -->
                    <div style="flex: 1;display:flex;flex-direction: column;justify-content: center;overflow: hidden;padding:10px 5px;border-bottom:1px solid #ebedf0">
                        <div style="display:flex;flex-direction: row;justify-content: space-between;overflow: hidden">
                            <span style="white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">{{item.title}}</span>
                            <span style="white-space: nowrap;font-size: 14px;color: #646566;">{{getTimeStr(item.createDate)}}</span>
                        </div>
                      <div style="display:flex;flex-direction: row;justify-content: space-between;overflow: hidden">
                          <div style="white-space: nowrap;text-overflow: ellipsis;overflow: hidden;font-size: 14px;color: #646566;">
                              <span style="color: #666666">{{item.message}}</span>
                          </div>
                          <!-- <van-tag :type="getStateTagType(item.state)" style="white-space: nowrap;margin-left: 10px;">{{consultStatus[item.state]}}</van-tag> -->
                      </div>
                    </div>
                </div>
            </van-list>

        </van-pull-refresh>
    </div>
</template>

<script>
  import {Toast} from 'vant';
  import axios from '../common/axios';
  import {responseCodes,consultStatus,consultReplyTypes,userTypes} from '../common/const'

  export default {
    name: "ConsultHistory.vue",
    props: {
      userType: {
        // required:true,
        validator: function (value) {
          if (!((typeof value)==="number")) {
            return  false
          }
          // 这个值必须匹配下列字符串中的一个
          return userTypes[value]
        }
      },
      openId:{
        type:String,
        required:false
      }
    },
    data() {
      return {
        list: [],
        loading: false,
        finished: false,
        refreshing: false,
        page:1,
        size:50,
        message:'',
        consultStatus,
        consultReplyType: consultReplyTypes,
        isCloseConsult:true,
        userTypes,
      };
    },
    computed:{

    },

    watch:{
      openId:{
        immediate:true,
        handler:function(newVal,oldVal){
			this.onRefresh();
        }
      }
    },
    methods: {
      async onLoad() {
          if (this.refreshing) {
            this.list = [];
            this.refreshing = false;
            this.page=1
          }

          if (this.finished){
            return ;
          }
        this.loading = true;
        let body = {};
		// if(this.openId){
		// 			console.log("this.userType:")
		// 			console.log(this.userType)
		// 			console.log(this.customer)
		//        body.openId =this.openId;
		//      }
   //      if (this.userType === userTypes.lawyer&&this.openId){
   //        body.answerOpenId= this.openId;
   //      } else if(this.userType === userTypes.customer){
			// console.log("this.userType:")
			// console.log(this.userType)
			// console.log(this.customer)
   //        body.openId =this.openId;
   //      }
	try {
			console.log("body:")
			console.log(body)
			console.log(this.openId);
let response = await axios.post(`/fyserve/aid/find?page=${this.page}&size=${this.size}`,body)
          let data = response.data;
          if (data.code === responseCodes.success) {let dataList = data.data.map((item) => {item.isExpanded = false;return item; })
			console.log(dataList)
            this.list.push(...dataList)
			console.log( this.list)
            this.page = this.page+1
            if (dataList.length<this.size) {
              this.finished = true;
            }
          }else{
            Toast.fail(data.message);
            this.finished = true
            this.loading = false;
          }
        }catch (e) {
            console.error(e)
            Toast.fail("加载数据失败")
            this.finished = true
            this.loading = false;
        }
        this.loading = false;
      },
      onRefresh() {
        this.refreshing = true;
        this.finished = false;
        this.loading = true;
        this.onLoad();
      },

      onClickLeft() {
        this.$router.back();
      },
      getTimeStr(createDateStr){
        return createDateStr.split(" ")[0]
      },
      getStateTagType(state){
        if (state ===consultStatus.finished){
          return "success"
        } else if (state ===consultStatus.handling){
          return "primary"
        } else if( state === consultStatus.undisposed){
          return "danger"
        } else {
          return "primary"
        }
      },
      onItemClick(item){
		console.log(item)
        this.$router.push({
          name:'ornotice-detail',
          params:{
            item,
            userType:this.userType
          }
        })
      }
    }
  }
</script>

<style scoped>
    .van-cell__title{
        font-size: 16px;
        flex: 3;
    }
    .van-cell:not(:last-child)::after{
        right: 16px;
    }
    .van-field__value::after{
        border: none;
    }
</style>